/**
 * Local blobs (Phase 16C C2): the patient signature PNG, kept as a data URL in the encrypted
 * `blobs` store until its VISIT_END op is applied. No photo capture offline (decision Q4).
 */
import { ulid } from '../ids';
import type { OfflineRuntime } from '../runtime';

export interface LocalBlob {
  blobId: string;
  mime: string;
  dataUrl: string;
  createdAt: string;
}

export class BlobRepo {
  constructor(private readonly rt: OfflineRuntime) {}

  async putDataUrl(dataUrl: string): Promise<string> {
    const match = /^data:([^;,]+)[;,]/.exec(dataUrl);
    const blobId = ulid(this.rt.now());
    const blob: LocalBlob = { blobId, mime: match?.[1] || 'application/octet-stream', dataUrl, createdAt: new Date(this.rt.now()).toISOString() };
    await this.rt.store().put('blobs', blobId, blob);
    return blobId;
  }

  async get(blobId: string): Promise<LocalBlob | undefined> {
    return this.rt.store().get<LocalBlob>('blobs', blobId);
  }

  async delete(blobId: string): Promise<void> {
    await this.rt.store().delete('blobs', blobId);
  }
}
